// Currency list — prefer useCurrencyCodes() / CurrencyContext which load from
// public.geography_currencies. This static list remains as a last-resort fallback.
export const currencies = [
  { code: 'USD', name: 'US Dollar' },
  { code: 'EUR', name: 'Euro' },
  { code: 'AED', name: 'AED (UAE Dirham)' },
  { code: 'SGD', name: 'SGD (Singapore Dollar)' },
  { code: 'AUD', name: 'AUD (Australian Dollar)' },
  { code: 'CAD', name: 'CAD (Canadian Dollar)' },
  { code: 'INR', name: 'Indian Rupee' },
];
